import api from '../../../api'

export function report(payload){
    return api.post("request-report", payload);
}
